type DensityClassMap = {
  mobile: string;
  tablet: string;
  desktop: string;
};

export const WORKSPACE_SPACING = {
  headerInsetX: {
    mobile: "px-3",
    tablet: "px-4",
    desktop: "px-6",
  } satisfies DensityClassMap,
  paneInsetX: {
    mobile: "px-3",
    tablet: "px-4",
    desktop: "px-6",
  } satisfies DensityClassMap,
  paneInsetY: {
    mobile: "py-3",
    tablet: "py-4",
    desktop: "py-4",
  } satisfies DensityClassMap,
  sectionGapPrimary: "space-y-4",
  sectionGapSecondary: "space-y-3",
  sectionGapTight: "space-y-2",
  innerSurfaceInsetX: "px-3",
  listRailInset: "p-3",
  listItemPadding: "p-3",
  listItemGap: "gap-3",
  statusStripInsetX: {
    mobile: "px-3",
    tablet: "px-4",
    desktop: "px-6",
  } satisfies DensityClassMap,
  statusStripInsetY: "py-2",
  calendarCanvasMargin: {
    mobile: "mx-3 mt-3 mb-4",
    tablet: "mx-4 my-4",
    desktop: "mx-6 my-6",
  } satisfies DensityClassMap,
  timelineCanvasInset: {
    mobile: "px-3 pt-3 pb-2",
    tablet: "px-4 pt-3 pb-2",
    desktop: "px-6 pt-4 pb-3",
  } satisfies DensityClassMap,
  timelineTrayHeaderInsetX: {
    mobile: "px-3",
    tablet: "px-4",
    desktop: "px-6",
  } satisfies DensityClassMap,
  timelineTrayBodyInsetX: {
    mobile: "px-3",
    tablet: "px-4",
    desktop: "px-6",
  } satisfies DensityClassMap,
} as const;

export function getDensityClass(
  isMobile: boolean,
  isTablet: boolean,
  classes: DensityClassMap,
): string {
  if (isMobile) return classes.mobile;
  if (isTablet) return classes.tablet;
  return classes.desktop;
}
